export enum CalendarItemEnum {
    Gmail = "gmail",
    Outlook = "outlook",
    Desktop = "desktop",
    Yahoo = "yahoo"
}